module.exports = __webpack_public_path__ + "static/posts-desktop-5669e16da43881e45fd6df945338828b.png";